// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Link as RouterLink, useLocation } from 'react-router-dom';

// project imports
import Search from './Search';
import Profile from './Profile';
import Notification from './Notification';
import MobileSection from './MobileSection';
import ThemeCustomize from './ThemeCustomize';
import { useAuth } from 'contexts/AuthContext';
import { getPageTitleFromPath } from 'utils/pageTitle';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const location = useLocation();
  const { isAdmin } = useAuth();

  const routeTitle = getPageTitleFromPath(location.pathname);
  const isDevicesPage = location.pathname === '/devices';

  return (
    <>
      <Box
        sx={{
          minWidth: 0,
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          overflowX: downLG ? 'auto' : 'visible',
          overflowY: 'hidden',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': { display: 'none' }
        }}
      >
        <Typography
          variant={downLG ? 'subtitle1' : 'h5'}
          sx={{
            flexShrink: 0,
            whiteSpace: 'nowrap',
            fontWeight: 600,
            lineHeight: 1.2
          }}
        >
          {routeTitle || 'Dashboard'}
        </Typography>
        {!downLG ? (
          <Box sx={{ flex: 1, minWidth: 120, maxWidth: 280 }}>
            <Search />
          </Box>
        ) : null}
      </Box>

      {isDevicesPage ? (
        <Button
          component={RouterLink}
          to="/settings?tab=pair-devices"
          variant="outlined"
          size="small"
          sx={{ flexShrink: 0, whiteSpace: 'nowrap', ml: downLG ? 0.5 : 0 }}
        >
          Pair & manage
        </Button>
      ) : null}

      {isAdmin ? <Notification /> : null}
      {!downLG && <ThemeCustomize />}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
}
